import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { debounceIfPossible } from "@faire/web--source/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useEffect, useMemo, useRef } from "react";

export const useFilterablePaginatedScroll = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  // sticky header height will be set to 0 when user scroll down, since it will be hidden
  // when we call scrollToTop, the offsetTop is calculated based on the sticky header height 0
  // this will result in the page not scrolling to the correct position
  // topOfPageContentHeightRef is to keep track of the actual header height
  const topOfPageContentHeightRef = useRef(0);
  const { headerPlusPromoBannerHeight } = useTopOfPageContent();

  useEffect(() => {
    if (headerPlusPromoBannerHeight) {
      topOfPageContentHeightRef.current = headerPlusPromoBannerHeight;
    }
  }, [headerPlusPromoBannerHeight]);

  const scrollToTop = useMemo(
    () =>
      debounceIfPossible((params: { toTop?: boolean }) => {
        let offsetTop = 0;
        if (params.toTop) {
          offsetTop = 0;
        } else if (scrollRef.current?.offsetTop) {
          offsetTop =
            scrollRef.current.offsetTop - topOfPageContentHeightRef.current;
        }
        getWindowOrThrow().scrollTo?.({
          top: offsetTop,
          left: 0,
          behavior: "smooth",
        });
      }, 100),
    []
  );

  return {
    scrollRef,
    scrollToTop,
  };
};
